import React, { useState } from "react";
import Register01 from "./register01";
import Register02 from "./register02";
function Register() {
  const [smsExpiresAt, setSmsExpiresAt] = useState(false);
  const [registeredMobile, setRegisteredMobile] = useState(false);

  if (!smsExpiresAt)
    return (
      <Register01
        onSetSmsExpiresAt={setSmsExpiresAt}
        onSetRegisteredMobile={setRegisteredMobile}
        registeredMobile={registeredMobile}
      />
    );
  return (
    <Register02
      registeredMobile={registeredMobile}
      smsExpiresAt={smsExpiresAt}
      resend={() => setSmsExpiresAt(false)}
    />
  );
}

export default Register;
